import { ApprovalStatus } from '@hooks/useAlbumInfo/types';

export interface ProfileProtection {
  feedName: string;
  licensorName: string;
  productTitle: string;
  artistName: string;
  explicitLyrics: boolean;
  approvalStatus: ApprovalStatus;
  primaryReleaseId: string;
  productType: string;
  includedMedia: string;
  originalReleaseDate: string;
  uri: string;
}

const MOCK_DATA: ProfileProtection[] = [
  {
    feedName: 'pkinteractive',
    licensorName: 'PK Interactive LLC',
    productTitle: 'Abre tu alma',
    artistName: 'Karmadame',
    explicitLyrics: false,
    approvalStatus: ApprovalStatus.NEEDS_APPROVAL,
    primaryReleaseId: '825723997099',
    productType: 'Single',
    includedMedia: 'Audio',
    originalReleaseDate: '2026-03-20',
    uri: 'spotify:album:4aawyAB9vmqN3uQ7FjRGTy',
  },
  {
    feedName: 'warner',
    licensorName: 'Warner Music Group',
    productTitle: 'Trade Places',
    artistName: 'Jack Harlow',
    explicitLyrics: true,
    approvalStatus: ApprovalStatus.APPROVED,
    primaryReleaseId: 'A10302B00136039217',
    productType: 'Single',
    includedMedia: 'Video',
    originalReleaseDate: '2026-03-13',
    uri: 'spotify:album:6AZyfcEWnR1y7DjR40Paih',
  },
  {
    feedName: 'fuga',
    licensorName: 'SoundOn',
    productTitle: 'My heart (Remastered 2025)',
    artistName: 'Dolin',
    explicitLyrics: false,
    approvalStatus: ApprovalStatus.EXPIRED,
    primaryReleaseId: '1008083799498',
    productType: 'Single',
    includedMedia: 'Audio',
    originalReleaseDate: '2026-01-22',
    uri: 'spotify:album:2noRn2Aes5aoNVsU6iWThc',
  },
  {
    feedName: 'pkinteractive',
    licensorName: 'PK Interactive LLC',
    productTitle: 'Bad Times',
    artistName: 'THE REVELATOR',
    explicitLyrics: true,
    approvalStatus: ApprovalStatus.DECLINED,
    primaryReleaseId: '821406824287',
    productType: 'EP',
    includedMedia: 'Audio',
    originalReleaseDate: '2026-03-13',
    uri: 'spotify:album:2vqe2h2bp7DspOQBDlYfmT',
  },
  {
    feedName: 'fuga',
    licensorName: 'PLATOON LTD',
    productTitle: 'The Future That Created My Past',
    artistName: 'Mark Williams',
    explicitLyrics: false,
    approvalStatus: ApprovalStatus.PARTIALLY_APPROVED,
    primaryReleaseId: '1006310483486',
    productType: 'Album',
    includedMedia: 'Audio',
    originalReleaseDate: '2026-01-30',
    uri: 'spotify:album:4ciHEo6K8Xd1wUCz5PFgLG',
  },
  {
    feedName: 'orchard',
    licensorName: 'The Orchard',
    productTitle: 'Taste Of It',
    artistName: 'Griffin Navarro',
    explicitLyrics: false,
    approvalStatus: ApprovalStatus.NO_APPROVAL_NEEDED,
    primaryReleaseId: '820233157254',
    productType: 'Single',
    includedMedia: 'Audio',
    originalReleaseDate: '2026-08-10',
    uri: 'spotify:album:6tMHq3qs3vV2kXK3N8PX5l',
  },
];

// TODO: replace with real API call when backend is ready
export const useGetProfileProtectionData = () => {
  return {
    data: MOCK_DATA,
    isLoading: false,
  };
};
